import gql from 'graphql-tag'

export const CAPITALIZE = gql`
  query Capitalization($citationsInput: [String!]!) {
    capitalization(citations: $citationsInput) {
      citations
    }
  }
`
